import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Divider, Typography } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import ManualTradeChart from "./ManualTradeChart";
import ManualTrade from "./ManualTrade";
import OrderDetailsTab from "./orderdetails/OderDetailsTab";

export default function ManualTradeSwitcher() {
	const [value, setValue] = React.useState("1");

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	return (
		<Box
			variant="section"
			sx={{
				minWidth: "100%",
				typography: "body1",
				ml: "2.2rem",
			}}>
			<TabContext value={value}>
				<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
					<TabList onChange={handleChange} aria-label="lab API tabs example">
						<Tab label="Chart" value="1" />
						<Tab label="Trade" value="2" />
						<Tab label="ORDER Details" value="3" />
						{/* <Tab label="Recent investmet" value="4" /> */}
					</TabList>
				</Box>
				<TabPanel value="1" sx={{ width: "100%", px: "0" }}>
					<ManualTradeChart />
					{/* <Typography
						variant="h5"
						sx={{ textAlign: "left", fontSize: "1.7rem" }}>
						{" "}
						$200,000.00{" "}
					</Typography> */}
				</TabPanel>
				<TabPanel value="2" sx={{ width: "99%", mx: "auto", px: "0" }}>
					<Box sx={{ width: "100%", px: "0" }}>
						<ManualTrade />
					</Box>
				</TabPanel>
				<TabPanel value="3">
					<OrderDetailsTab />
				</TabPanel>
				{/* <TabPanel value="4">
					<Typography
						variant="h5"
						sx={{
							textAlign: "left",
							fontSize: "1.7rem",
						}}>
						{" "}
						$45,000.00{" "}
					</Typography>
				</TabPanel> */}
			</TabContext>
		</Box>
	);
}
